(function () {
  angular.module("akitabox.ui.directives.autocomplete", [
    "ngMaterial",
    "akitabox.core",
    "akitabox.ui.dialogs.autocomplete",
  ]);
})();
